module.exports = __webpack_public_path__ + "img/0Q3B8222_Black.1abf3950.jpg";